import { List, Record } from 'immutable';

import Hydrator from 'utils/Hydrator';

import FundingEnquiryActions from './FundingEnquiryActionsModel';
import FundingEnquiryAnswers from './FundingEnquiryAnswersModel';
import FundingEnquiryQuestionnaire from './FundingEnquiryQuestionnaireModel';
import FundingEnquiryUser from './FundingEnquiryUserModel';

const FundingEnquiryRecord = Record({
  actions: List(),
  answers: null,
  createdAt: new Date(0),
  report: null,
  search: null,
  id: 0,
  questionnaire: null,
  status: '',
  user: null,
  updatedAt: new Date(0),
});

export default class FundingEnquiry extends FundingEnquiryRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined') {
      return undefined;
    }

    const mapProperties = {
      actions: Hydrator.fromList(FundingEnquiryActions.deserialize),
      answers: FundingEnquiryAnswers.deserialize,
      createdAt: Hydrator.timestamp2Date,
      questionnaire: FundingEnquiryQuestionnaire.deserialize,
      updatedAt: Hydrator.timestamp2Date,
      user: FundingEnquiryUser.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new FundingEnquiry(hydrated);
  }
}
